import type { IContact, IMissionCardDetails } from '@bloomays-lib/types.shared';

import { EditMissionDrawer } from './EditMissionDrawer';
import { ShortenModal } from './ShortenModal';
import { EstimateModal } from './EstimateModal';
import { PriceHistoryModal } from './PriceHistoryModal';
import { DeleteModal } from './DeleteModal';
import { AmendmentModal } from './AmendmentModal';

export type MissionActionKey = 'shorten' | 'amendment' | 'modify' | 'assessment' | 'prices' | 'delete' | null;

export type MissionActionsHostProps = {
  openKey: MissionActionKey;
  onClose: () => void;
  onOpen: (key: MissionActionKey) => void;
  mission: IMissionCardDetails;
  jobOwnerName?: string;
  /** Un contrat principal SST/PDS a été envoyé en signature ou signé : fige les délais de paiement (TEC-3211). */
  contractsEngaged?: boolean;
  legalClientContact?: IContact;
  legalClientSourceLabel?: string;
  legalBloomerContact?: IContact;
  legalBloomerSourceLabel?: string;
  legalContactUnavailableText?: string;
};

/**
 * Orchestrateur des actions mission V2 : monte la popin/drawer correspondant à `openKey`
 * (rendu conditionnel → état de formulaire frais à chaque ouverture). Les écrans qui aboutissent
 * à un avenant rappellent `onOpen('amendment')`.
 */
export const MissionActionsHost = ({
  openKey,
  onClose,
  onOpen,
  mission,
  jobOwnerName,
  contractsEngaged,
  legalClientContact,
  legalClientSourceLabel,
  legalBloomerContact,
  legalBloomerSourceLabel,
  legalContactUnavailableText,
}: MissionActionsHostProps) => {
  const openAmendment = () => onOpen('amendment');
  return (
    <>
      {openKey === 'modify' ? (
        <EditMissionDrawer
          open
          onClose={onClose}
          onCreateAmendment={openAmendment}
          mission={mission}
          jobOwnerName={jobOwnerName}
          contractsEngaged={contractsEngaged}
        />
      ) : null}
      {openKey === 'shorten' ? <ShortenModal open onClose={onClose} mission={mission} /> : null}
      {openKey === 'assessment' ? (
        <EstimateModal open onClose={onClose} onCreateAmendment={openAmendment} mission={mission} />
      ) : null}
      {openKey === 'prices' ? (
        <PriceHistoryModal open onClose={onClose} onCreateAmendment={openAmendment} mission={mission} />
      ) : null}
      {openKey === 'delete' ? <DeleteModal open onClose={onClose} mission={mission} /> : null}
      {openKey === 'amendment' ? (
        <AmendmentModal
          open
          onClose={onClose}
          mission={mission}
          legalClientContact={legalClientContact}
          legalClientSourceLabel={legalClientSourceLabel}
          legalBloomerContact={legalBloomerContact}
          legalBloomerSourceLabel={legalBloomerSourceLabel}
          legalContactUnavailableText={legalContactUnavailableText}
        />
      ) : null}
    </>
  );
};

export default MissionActionsHost;
